export default import.meta.ROLLUP_FILE_URL_BJH6L7Js;